export function hasPermission(action, permissions) {
	// permissions come from the options injected in app.js to the 'can' plugin
	return permissions.includes(action) ? true : false;
}

export const Can = {
	install: function(app, options) {
		const hp = (action, permissions = options.value) => hasPermission(action, permissions);
		app.config.globalProperties.can = hp;
		app.provide('can', hp);
	}
}